import React from 'react';
import { StyleSheet, View } from 'react-native';
import { Theme, ThemeConsumer } from '@rneui/themed';
import { ZenIcon, ZenText } from 'zen-core-elements';
import { useAppSelector } from '../../../redux/hooks';

// Messages from the last engine run: discounts that dropped, caps reached, items skipped
const DiscountMessages = () => {
	const { id: locationId } = useAppSelector((state) => state?.common?.currentLocation)
	const messages = useAppSelector((state) => state?.NewSellscreenSlice?.pricedCart?.[locationId]?.messages) ?? []
	if (!messages.length) return null
	return (
		<ThemeConsumer>
			{({ theme }) => {
				const styles = style(theme)
				return (
					<View style={styles.container}>
						{messages.map((message, index) => (
							<View key={index} style={styles.row}>
								<ZenIcon type='material-community' name={message.severity === "warning" ? 'alert-circle-outline' : 'information-outline'} size={14} color={message.severity === "warning" ? theme?.goldenOrange : theme?.blue600} />
								<ZenText content={message.text} style={styles.text} />
							</View>
						))}
					</View>
				)
			}}
		</ThemeConsumer>
	)
}

const style = (theme: Theme) => StyleSheet.create({
	container: { backgroundColor: theme?.warmCream, borderRadius: 10, padding: 10, gap: 6, marginBottom: 12 },
	row: { flexDirection: 'row', gap: 6, alignItems: 'flex-start' },
	text: { flex: 1, fontSize: theme?.badgeFontSize, fontFamily: theme?.medium, color: theme?.lightDark },
})

export default DiscountMessages
